//引入Vue
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入App
import App from './App.vue'
//引入VueRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'core-js/stable';
import 'regenerator-runtime/runtime';

Vue.use(VueAxios, axios)
Vue.use(ElementUI, { size: 'large', zIndex: 3000 });

//关闭Vue的生产提示
// Vue.config.productionTip = false
//应用插件
Vue.use(VueRouter)

//创建vm
new Vue({
	el:'#app',
	render: h => h(App),
	router:router
})
